import { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { setPageName } from "../redux/actions";
import { goPage } from "../system/coords";

import Logo from "../components/logo";
const ArrowIcon = "/assets/images/arrow.svg";

// My availability status
const availableFrom = { day: 1, month: 7 - 1, year: 2026 };

const getAvailability = () => {
  const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
  const oneMonthInSecs = 31 * 24 * 60 * 60;
  const oneWeekInSecs = 7 * 24 * 60 * 60;

  // Set defaults
  let availabilityStatus = "Unavailable";
  let availabilityDate = `Until ${months[availableFrom.month]} ${availableFrom.year}`;

  // Set availabile date
  const availableDate = new Date(availableFrom.year, availableFrom.month, availableFrom.day, 0, 0, 0, 0);
  const availableEpoch = Number.parseInt(availableDate.getTime() / 1000, 10);

  // Set now date
  const nowDate = new Date();
  const nowEpoch = Number.parseInt(nowDate.getTime() / 1000, 10);

  // Less than 2 months till available?
  if (nowEpoch >= availableEpoch - 2 * oneMonthInSecs) {
    availabilityStatus = "Available";
    availabilityDate = `From ${months[availableFrom.month]} ${availableFrom.year}`;
  }
  // Less than 1 week till available?
  if (nowEpoch >= availableEpoch - oneWeekInSecs) {
    availabilityStatus = "Available";
    availabilityDate = "Get in contact!";
  }

  return { availabilityStatus, availabilityDate };
};

const Availability = () => {
  const { availabilityStatus, availabilityDate } = getAvailability();
  const [currentLanguageIndex, setCurrentLanguageIndex] = useState(0);

  const availibilityClass = "Available" === availabilityStatus ? "statusAvailable" : "statusUnavailable";
  const dispatch = useDispatch();

  // Different programming language syntaxes for availability
  const languageFormats = [
    // JavaScript/JSX
    {
      opening: "<Availability />: ",
      closing: `{${availabilityStatus}}`,
      className: "jsx",
    },
    // PHP
    {
      opening: '<?php echo "Availability: ',
      closing: `${availabilityStatus}"; ?>`,
      className: "php",
    },
    // Shell/Bash
    {
      opening: 'echo "Availability: ',
      closing: `${availabilityStatus}"`,
      className: "shell",
    },
    // C
    {
      opening: 'printf("Availability: %s", "',
      closing: `${availabilityStatus}");`,
      className: "c",
    },
    // SQL
    {
      opening: "SELECT 'Availability: ",
      closing: `${availabilityStatus}' AS status;`,
      className: "sql",
    },
    // CSS
    {
      opening: '.availability::after { content: "',
      closing: `${availabilityStatus}"; }`,
      className: "css",
    },
    // HTML
    {
      opening: '<span class="availability">',
      closing: `${availabilityStatus}</span>`,
      className: "html",
    },
    // Java
    {
      opening: 'System.out.println("Availability: ',
      closing: `${availabilityStatus}");`,
      className: "java",
    },
  ];

  // Cycle through languages every 5 seconds
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentLanguageIndex(prevIndex => (prevIndex + 1) % languageFormats.length);
    }, 5000);

    return () => clearInterval(interval);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const currentFormat = languageFormats[currentLanguageIndex];

  return (
    <>
      <code
        className="Home-availability"
        onClick={() => {
          goPage("Contact");
          dispatch(setPageName("Contact"));
        }}
      >
        <div className="tag">{currentFormat.opening}</div>
        <div className={availibilityClass}>{currentFormat.closing}</div>
        <div className="date">{availabilityDate}</div>
      </code>
    </>
  );
};

const HomeContent = () => {
  const dispatch = useDispatch();

  // Check if we're on mattpass.dev domain
  const isMattpassDev = window.location.hostname.includes("mattpass.dev");
  const introText = isMattpassDev ? "Hi, I'm" : "Welcome to";

  return (
    <div className="center full-height">
      <img
        src={ArrowIcon}
        className="Arrow-icon Arrow-Home"
        alt="Go to next page"
        onClick={() => {
          goPage("About");
          dispatch(setPageName("About"));
        }}
      />
      <div className="Home-intro">{introText}</div>
      <div className="Page-logo">
        <Logo />
      </div>
      {isMattpassDev ? (
        <Availability />
      ) : (
        <div className="Home-intro-company">
          Web App Development <span className="pipe" /> Cyber Security <span className="pipe" /> Data Processing
        </div>
      )}
    </div>
  );
};

export default HomeContent;
